import React from 'react';
import styled from 'styled-components';
import { AdvancedSetting } from 'api/advanced-settings/settings-types';
import { PageLoading } from 'components/atoms/loading';
import { toastService } from 'components/molecules/toast';
import { useTranslate } from 'hooks/use-translation';
import {
  useMutateAdvancedSettingsConfig,
  useQueryAdvancedSettingsConfig,
} from 'queries/advanced-settings/advanced-settings';
import { PhaseAutomation } from './phase-automation';
import { ScheduledNotifications } from './scheduled-notifications';
import { StatusAutomation } from './status-automation';

const Wrapper = styled.div`
  margin-bottom: var(--layout-04);
`;

export const AdvancedSettings = () => {
  const translate = useTranslate();
  const { mutate } = useMutateAdvancedSettingsConfig();
  const { data: advancedSettingsConfig = [], status } =
    useQueryAdvancedSettingsConfig();

  const handleChange = (updatedSettings: AdvancedSetting) => {
    mutate(updatedSettings, {
      onError: () => {
        toastService({
          title: translate('failure'),
          message: translate('settings.advanced.failed.message'),
        }).error();
      },
    });
  };

  switch (status) {
    case 'success': {
      if (advancedSettingsConfig.length) {
        return (
          <>
            <Wrapper>
              <StatusAutomation
                settingsConfig={advancedSettingsConfig}
                onSettingChange={handleChange}
              />
            </Wrapper>
            <Wrapper>
              <PhaseAutomation
                settingsConfig={advancedSettingsConfig}
                onSettingChange={handleChange}
              />
            </Wrapper>
            <Wrapper>
              <ScheduledNotifications
                settingsConfig={advancedSettingsConfig}
                onSettingChange={handleChange}
              />
            </Wrapper>
          </>
        );
      }

      return null;
    }

    case 'loading': {
      return <PageLoading />;
    }

    case 'error':
    case 'idle':
    default: {
      return null;
    }
  }
};
